/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { getUproColor } from "utils/colors";
import { makeNiceText } from "utils/formatters";
import { getFoodIcon } from "utils/foodIcons";
import SoftBadge from "components/SoftBadge";
import dayjs from "dayjs";

const estadoConfig = {
  Pendiente: { color: "warning", label: "Pendiente" },
  EnProceso: { color: "info", label: "En proceso" },
  Finalizado: { color: "success", label: "Finalizado" },
  Anulado: { color: "error", label: "Anulado" },
  Vencido: { color: "secondary", label: "Vencido" },
};

const getRows = (data, handleOpenMenu) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      const { color, label } = estadoConfig[item.estado] || { color: "default", label: "Desconocido" };
      rows.push({
        type: (
          <SoftBox
            onClick={(e) => handleOpenMenu(e, item)}
            display="flex"
            alignItems="center"
            sx={{
              cursor: item.estado != "Finalizado" && item.estado != "Anulado" ? "pointer" : "default",
            }}
          >
            <SoftBox pl={3} mr={2} display="flex">
              {/* <Tooltip
                title={`${item?.producto?.categoriaProducto?.categoria} ${
                  item?.disponibilidad ? "- Disponible" : "- No disponible"
                }`}
                placement="top"
              > */}
              <Icon
                sx={{
                  verticalAlign: "middle",
                  cursor: "pointer",
                  color: item.producto?.disponibilidad
                    ? getUproColor("uproGreen")
                    : getUproColor("secondary"),
                }}
                fontSize="lg"
              >
                {getFoodIcon(item?.producto?.categoriaProducto?.categoria)}
              </Icon>
              {/* </Tooltip> */}
              {item.combo && (
                <Tooltip title={`Combo`} placement="top">
                  <Icon
                    sx={{
                      verticalAlign: "middle",
                      cursor: "pointer",
                      color: item.disponibilidad ? getUproColor("uproPink") : "inherit",
                    }}
                    fontSize="lg"
                  >
                    cached
                  </Icon>
                </Tooltip>
              )}
            </SoftBox>
          </SoftBox>
        ),
        id: (
          <SoftBox onClick={(e) => handleOpenMenu(e, item)} sx={{
            cursor: item.estado != "Finalizado" && item.estado != "Anulado" ? "pointer" : "default",
          }}>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color={item?.id ? "text" : "secondary"}
              fontWeight="bold"
            >
              {item?.id}
            </SoftTypography>
          </SoftBox>
        ),
        nombre: (
          <SoftBox onClick={(e) => handleOpenMenu(e, item)} sx={{
            cursor: item.estado != "Finalizado" && item.estado != "Anulado" ? "pointer" : "default",
          }}>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              fontWeight="medium"
              color={item?.producto?.disponibilidad ? "text" : "secondary"}
            >
              {item?.producto?.nombre ? makeNiceText(item?.producto?.nombre) : "Sin nombre"}
            </SoftTypography>
          </SoftBox>
        ),
        categoriaProducto: (
          <SoftBox onClick={(e) => handleOpenMenu(e, item)} sx={{
            cursor: item.estado != "Finalizado" && item.estado != "Anulado" ? "pointer" : "default",
          }}>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.producto?.categoriaProducto?.categoria}
            </SoftTypography>
          </SoftBox>
        ),
        // tipoProducto: (
        //   <SoftBox onClick={(e) => handleOpenMenu(e, item)} sx={{
        //     cursor: item.estado != "Finalizado" && item.estado != "Anulado" ? "pointer" : "default",
        //   }}>
        //     <SoftTypography
        //       verticalAlign="text-top"
        //       variant="caption"
        //       color="secondary"
        //       fontWeight="medium"
        //     >
        //       {item?.producto?.tipoProducto?.tipo || "-"}
        //     </SoftTypography>
        //   </SoftBox>
        // ),
        cantPorciones: (
          <SoftBox onClick={(e) => handleOpenMenu(e, item)} sx={{
            cursor: item.estado != "Finalizado" && item.estado != "Anulado" ? "pointer" : "default",
          }}>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.cantPorciones || 0}
            </SoftTypography>
          </SoftBox>
        ),
        observaciones: (
          <SoftBox onClick={(e) => handleOpenMenu(e, item)} sx={{
            cursor: item.estado != "Finalizado" && item.estado != "Anulado" ? "pointer" : "default",
          }}>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.observaciones || "Sin observaciones"}
            </SoftTypography>
          </SoftBox>
        ),
        fechaEsperadaEntrega: (
          <SoftBox onClick={(e) => handleOpenMenu(e, item)} sx={{
            cursor: item.estado != "Finalizado" && item.estado != "Anulado" ? "pointer" : "default",
          }}>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {dayjs(item?.fechaEsperadaEntrega).format("DD/MM/YYYY") || "Sin fecha de entrega"}
            </SoftTypography>
          </SoftBox>
        ),
        estado: (
          <SoftBox onClick={(e) => handleOpenMenu(e, item)} sx={{ cursor: "pointer" }}>
            <SoftBox>
              <SoftBadge color={color} size="xs" badgeContent={label} container circular />
            </SoftBox>
          </SoftBox>
        ),
        accion: (
          <SoftBox
            mr={2}
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
            display="flex"
          >
            <Tooltip title="Opciones" placement="top">
              <Icon
                sx={{ color: getUproColor("uproGreen"), cursor: "pointer", mx: 0.5 }}
                fontSize="small"
                onClick={(e) => handleOpenMenu(e, item)}
              >
                more_vert
              </Icon>
            </Tooltip>
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "type", desc: " ", align: "left", width: "1%", noOrder: true },
  { name: "id", desc: "ID", align: "left", width: "1%" },
  { name: "nombre", desc: "Nombre", align: "left" },
  { name: "categoriaProducto", desc: "Categoria", align: "left" },
  // { name: "tipoProducto", desc: "Tipo", align: "left" },
  { name: "cantPorciones", desc: "cantidad", align: "center" },
  { name: "observaciones", desc: "osbservaciones", align: "center" },
  { name: "fechaEsperadaEntrega", desc: "fecha de ejecución", align: "center" },
  { name: "estado", desc: "estado", align: "center" },
  { name: "accion", desc: " ", align: "center", width: "1%", noOrder: true },
];

export default { columns, getRows };
